// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3qNi2","options":"AnswerScale_options__3eXGM","selected":"AnswerScale_selected__2T9yx"};